import React from 'react';
import { Navigate } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ui/ErrorBoundary';
import { QuoteFormErrorFallback, PaymentErrorFallback } from '@/components/ui/ErrorBoundary';

// Customer route imports - COPIED EXACTLY from App.tsx
const Dashboard = React.lazy(() => import('@/pages/Dashboard'));
const Cart = React.lazy(() => import('@/pages/Cart'));
const Checkout = React.lazy(() => import('@/pages/CheckoutShopify'));
const OrderConfirmation = React.lazy(() => import('@/pages/OrderConfirmation'));
const UniversalOrderPage = React.lazy(() => import('@/pages/orders/UniversalOrderPage'));
const CustomerQuotesList = React.lazy(() => import('@/pages/CustomerQuotesList'));
const ShopifyStyleQuoteView = React.lazy(() => import('@/components/quotes/ShopifyStyleQuoteView'));
const CustomerRevisionApprovalPage = React.lazy(() => import('@/pages/CustomerRevisionApprovalPage'));
const CustomerOrdersList = React.lazy(() => import('@/pages/CustomerOrdersList'));
const MyTicketsPage = React.lazy(() => import('@/pages/support/MyTicketsOptimized'));
const Profile = React.lazy(() => import('@/pages/Profile'));
const Address = React.lazy(() => import('@/pages/profile/Address'));
const MyWarehouseAddresses = React.lazy(() => import('@/pages/MyWarehouseAddresses'));
const MyPackages = React.lazy(() => import('@/pages/MyPackages'));
const MyConsolidations = React.lazy(() => import('@/pages/MyConsolidations'));
const ConsolidationDetailPage = React.lazy(() => import('@/pages/ConsolidationDetailPage'));
const ClaimPackage = React.lazy(() => import('@/pages/ClaimPackage'));

// Customer-facing routes (requires authentication)
export const customerRoutes = [
  {
    path: 'dashboard',
    element: <Dashboard />,
  },
  {
    path: 'cart',
    element: <Cart />,
  },
  {
    path: 'checkout',
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <Checkout />
      </ErrorBoundary>
    ),
  },
  {
    path: 'order-confirmation/:orderId',
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <OrderConfirmation />
      </ErrorBoundary>
    ),
  },
  // Universal Order Page (NEW - handles all order types)
  {
    path: 'orders/:orderId',
    element: (
      <ErrorBoundary fallback={PaymentErrorFallback}>
        <UniversalOrderPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'dashboard/quotes',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <CustomerQuotesList />
      </ErrorBoundary>
    ),
  },
  {
    path: 'dashboard/quotes/:id',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <ShopifyStyleQuoteView viewMode="customer" />
      </ErrorBoundary>
    ),
  },
  {
    path: 'revision/:revisionId',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <CustomerRevisionApprovalPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'dashboard/orders',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <CustomerOrdersList />
      </ErrorBoundary>
    ),
  },
  {
    path: 'support',
    element: <Navigate to="/support/my-tickets" replace />,
  },
  {
    path: 'support/my-tickets',
    element: <MyTicketsPage />,
  },
  {
    path: 'quote/:id',
    element: <Navigate to="/admin/quotes" replace />, // Redirect to admin quotes
  },
  {
    path: 'messages',
    element: <Navigate to="/support/my-tickets" replace />,
  },
  {
    path: 'profile',
    element: <Profile />,
  },
  {
    path: 'profile/address',
    element: <Address />,
  },

  // Customer Warehouse Management
  {
    path: 'my-addresses',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <MyWarehouseAddresses />
      </ErrorBoundary>
    ),
  },
  {
    path: 'my-packages',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <MyPackages />
      </ErrorBoundary>
    ),
  },
  {
    path: 'my-consolidations',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <MyConsolidations />
      </ErrorBoundary>
    ),
  },
  {
    path: 'my-consolidation/:id',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <ConsolidationDetailPage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'claim-package',
    element: (
      <ErrorBoundary fallback={QuoteFormErrorFallback}>
        <ClaimPackage />
      </ErrorBoundary>
    ),
  },
  {
    path: 'quotes/:id',
    element: <Navigate to="/admin/quotes" replace />, // Redirect to admin quotes
  },
];